// Claude: renamed from subscriptionSlice.ts — seller-subscriptions 08-Apr-2026
// Claude: rfxLimit added 10-Apr-2026
// Claude: removed unused fields (emailSearch, relevanceMapping, notesFeature, meetingType, promoteTopListing, isChatAllowed, isAnnouncementsAllowed) 10-Apr-2026
// Claude: rfxResponsePendingLimit, subscriptionValue, currency added 20-04-2026
// Claude: rfxInterestedLimit removed 24-04-2026
// Claude: store numeric fields as strings so backspace works; parse only at submit 23-04-2026
import { createSlice } from "@reduxjs/toolkit";

const sellerSubscriptionSlice = createSlice({
  name: "sellerSubscription",

  initialState: {
    subscriptions: [],
    planName: '',
    sellerTagsLimit: '0',
    pendingMeetingsLimit: '0',
    digitalAssetsLimit: '0',
    rfxLimit: '0',
    rfxResponsePendingLimit: '0',
    subscriptionValue: '0',
    currency: '',
    isActive: false,
  },

  reducers: {
    setSubscriptions: (state, action) => {
      state.subscriptions = action.payload;
    },
    setPlanName: (state, action) => {
      state.planName = action.payload;
    },
    setSellerTagsLimit: (state, action) => {
      state.sellerTagsLimit = action.payload;
    },
    setPendingMeetingsLimit: (state, action) => {
      state.pendingMeetingsLimit = action.payload;
    },
    setDigitalAssetsLimit: (state, action) => {
      state.digitalAssetsLimit = action.payload;
    },
    setRfxLimit: (state, action) => {
      state.rfxLimit = action.payload;
    },
    setRfxResponsePendingLimit: (state, action) => {
      state.rfxResponsePendingLimit = action.payload;
    },
    setSubscriptionValue: (state, action) => {
      state.subscriptionValue = action.payload;
    },
    setCurrency: (state, action) => {
      state.currency = action.payload;
    },
    setIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    resetForm: (state) => {
      state.planName = ''
      state.sellerTagsLimit = '0'
      state.pendingMeetingsLimit = '0'
      state.digitalAssetsLimit = '0'
      state.rfxLimit = '0'
      state.rfxResponsePendingLimit = '0'
      state.subscriptionValue = '0'
      state.currency = ''
      state.isActive = false
    }
  },
});

export const { resetForm, setDigitalAssetsLimit,
  setSellerTagsLimit, setIsActive, setPendingMeetingsLimit, setPlanName,
  setRfxLimit, setRfxResponsePendingLimit, setSubscriptionValue, setCurrency,
  setSubscriptions
} = sellerSubscriptionSlice.actions;

export const sellerSubscriptionReducer = sellerSubscriptionSlice.reducer;
